import { usePermissions, useTranslate } from "ra-core";
import { Link } from "react-router";
import { REPORTS } from "./registry";

/** /rapports: one card per enabled report (spec 09 §5). */
export const ReportsIndex = () => {
  const translate = useTranslate();
  const { permissions } = usePermissions();
  const isAdmin = permissions === "admin";
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-extrabold">
        {translate("gavion.reports.index.title")}
      </h1>
      <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3 min-[120rem]:grid-cols-4 min-[160rem]:grid-cols-5">
        {REPORTS.filter((r) => r.enabled && (isAdmin || !r.adminOnly)).map(
          (r) => (
            <li key={r.key}>
              <Link
                to={r.path}
                className="flex h-full gap-3 rounded-xl border bg-card p-4 outline-none hover:border-primary focus-visible:ring-2 focus-visible:ring-ring"
              >
                <r.icon
                  className="size-5 shrink-0 text-primary"
                  aria-hidden="true"
                />
                <span>
                  <span className="block font-bold">
                    {translate(r.titleKey)}
                  </span>
                  <span className="block text-sm text-muted-foreground">
                    {translate(r.descriptionKey)}
                  </span>
                </span>
              </Link>
            </li>
          ),
        )}
      </ul>
    </div>
  );
};
